export default __webpack_public_path__ + "static/media/VK.85c29f8b.svg";